import { render } from "./dots.vue?vue&type=template&id=4c8832f6&ts=true"
import script from "./dots.vue?vue&type=script&lang=ts"
export * from "./dots.vue?vue&type=script&lang=ts"

import exportComponent from "/working_dir/Loupey.WebApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__